<template>
    <!-- The edit / add model -->
    <!-- modal-xl -->
    <b-modal size="xxl" id="certificateEditModal" title="Certificate Edit" title-class="font-18" hide-footer ref="certificateEditModal">
        <b-overlay :show="show" rounded="sm" v-if="hasMounted">
            <div class="row row-container">
                <div class="left-pane">
                    <div>
                        <b-tabs content-class="mt-3">
                            <b-tab title="Certificate" active>
                                <b-form-group
                                    label-size="sm"
                                    label="Supplier Name:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="4"
                                >
                                    <b-form-input
                                        v-model="$v.certificate_details.company_name.$model"
                                        :state="validateState('company_name')"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        type="text"
                                        class="b-form-input"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group
                                    label-size="sm"
                                    label="BEE Level:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="4"
                                >
                                    <b-form-select
                                        v-model="$v.certificate_details.bbbee_level.$model"
                                        :state="validateState('bbbee_level')"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        :options="bee_level_options"
                                        class="b-form-input"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group label="Comapny Size:" label-size="sm" label-cols-sm="4" class="b-form-group align-text-setting">
                                    <b-form-select
                                        v-model="$v.certificate_details.company_size.$model"
                                        :state="validateState('company_size')"
                                        aria-describedby="input-1-live-feedback"
                                        :options="company_size_options"
                                        size="sm"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group label="Sector Code:" label-size="sm" label-cols-sm="4" class="b-form-group align-text-setting">
                                    <b-form-select
                                        v-model="$v.certificate_details.sector_code_id.$model"
                                        :state="validateState('sector_code_id')"
                                        aria-describedby="input-1-live-feedback"
                                        :options="sector_code_options"
                                        size="sm"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group label-size="sm" label="Vat no:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4">
                                    <b-form-input
                                        disabled
                                        v-model="$v.certificate_details.vat_no.$model"
                                        :state="validateState('vat_no')"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        type="text"
                                        class="b-form-input not-allowed-pointer"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                        {{ vatNoErrorMessage }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group
                                    label-size="sm"
                                    label="Company reg no:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="4"
                                >
                                    <b-form-input
                                        disabled
                                        v-model="$v.certificate_details.company_reg.$model"
                                        :state="validateState('company_reg')"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        type="text"
                                        class="b-form-input not-allowed-pointer"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                        {{ regNoErrorMessage }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group label-size="sm" label="Certificate No:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4">
                                    <b-form-input
                                        v-model="certificate_details.certificate_no"                            
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        type="text"
                                        class="b-form-input"
                                    ></b-form-input>                                    
                                </b-form-group>

                                <b-form-group label="Issue Date" label-cols-sm="4" label-size="sm" class="b-form-group align-text-setting">
                                    <!-- <b-form-datepicker v-model="value1" class="mb-2"></b-form-datepicker> -->
                                    <b-form-input
                                        v-model="$v.certificate_details.issue_date.$model"
                                        :state="validateState('issue_date')"
                                        aria-describedby="input-1-live-feedback"
                                        id="date"
                                        type="date"
                                        size="sm"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group label="Expiry Date:" label-cols-sm="4" label-size="sm" class="b-form-group align-text-setting">
                                    <!-- <b-form-datepicker v-model="value2" class="mb-2"></b-form-datepicker> -->
                                    <b-form-input
                                        v-model="$v.certificate_details.expiry_date.$model"
                                        :state="validateState('expiry_date')"
                                        aria-describedby="input-1-live-feedback"
                                        id="date"
                                        type="date"
                                        size="sm"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group label="Sharing status:" label-cols-sm="4" label-size="sm" class="b-form-group align-text-setting">
                                    <b-form-input
                                        disabled
                                        v-model="certificate_details.share_status"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                    ></b-form-input>
                                </b-form-group>

                                <b-form-group
                                    label-size="sm"
                                    label="Doc Type:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="4"
                                >
                                    <b-form-select
                                        v-model="$v.certificate_details.document_type.$model"
                                        @change="set_verification_agency"
                                        :state="validateState('document_type')"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        :options="doc_type_options"
                                        class="b-form-input"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group
                                    v-if="certificate_details.document_type == 'Certificate'"
                                    label-size="sm"
                                    label="Agency:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="4"
                                >
                                    <b-form-select
                                        v-model="$v.certificate_details.verification_agency_id.$model"
                                        :state="validateState('verification_agency_id')"
                                        @change="set_verification_agency"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        :options="agency_options"
                                        class="b-form-input"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>
                            </b-tab>
                            <b-tab v-if="findPermission('Add and Edit BEE Data') || isTypeUser" title="BBBEE Data">
                                <div v-if="certificate_details.document_type == 'Certificate'">
                                    <b-form-group
                                        label-size="sm"
                                        label="Ownership Score:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-input
                                            v-model="certificate_details.own_score"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            class="b-form-input"
                                            type="number"
                                            v-on:keypress="NumbersOnly"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label-size="sm"
                                        label="Management Control Score:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-input
                                            v-model="certificate_details.mc_score"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            class="b-form-input"
                                            type="number"
                                            v-on:keypress="NumbersOnly"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label-size="sm"
                                        label="Socio Economic Development Score:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-input
                                            v-model="certificate_details.sed_score"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            class="b-form-input"
                                            type="number"
                                            v-on:keypress="NumbersOnly"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label-size="sm"
                                        label="Enterprise & Supplier Development Score:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-input
                                            v-model="certificate_details.esd_score"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            class="b-form-input"
                                            type="number"
                                            v-on:keypress="NumbersOnly"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label-size="sm"
                                        label="Preferential Procurement Score:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-input
                                            v-model="certificate_details.pp_score"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            class="b-form-input"
                                            type="number"
                                            v-on:keypress="NumbersOnly"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label-size="sm"
                                        label="Skills Development Score:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-input
                                            v-model="certificate_details.sd_score"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            class="b-form-input"
                                            type="number"
                                            v-on:keypress="NumbersOnly"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        v-if="certificate_details.sector_code_id == 'Financial'"
                                        label-size="sm"
                                        label="Access to Finance Score:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-input
                                            v-model="certificate_details.a2f_score"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            class="b-form-input"
                                            type="number"
                                            v-on:keypress="NumbersOnly"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        v-if="certificate_details.sector_code_id == 'Financial'"
                                        label-size="sm"
                                        label="Empowerment Finance Score:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-input
                                            v-model="certificate_details.ef_score"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            class="b-form-input"
                                            type="number"
                                            v-on:keypress="NumbersOnly"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label-size="sm"
                                        label="Enterprise Development Score:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-input
                                            v-model="certificate_details.ed_score"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            class="b-form-input"
                                            type="number"
                                            v-on:keypress="NumbersOnly"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label-size="sm"
                                        label="Total Score:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-input
                                            v-model="certificate_details.total_score"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            class="b-form-input"
                                            type="text"
                                            v-on:keypress="NumbersOnly"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label-size="sm"
                                        label="Yes Enhancement:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-select
                                            v-model="certificate_details.yes_enhancement"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            :options="yes_enhancement_options"
                                            class="b-form-input"
                                        ></b-form-select>
                                        <!-- <b-form-input aria-describedby="input-1-live-feedback" size="sm" type="text" class="b-form-input"></b-form-input> -->
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label-size="sm"
                                        label="Flow Through Applied:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-select
                                            v-model="certificate_details.flow_through_applied"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            :options="flow_through_applied_options"
                                            class="b-form-input"
                                        ></b-form-select>
                                        <!-- <b-form-input aria-describedby="input-1-live-feedback" size="sm" type="text" class="b-form-input"></b-form-input> -->
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label-size="sm"
                                        label="Designated Group Supplier:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-select
                                            v-model="certificate_details.designated_group_supplier"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            :options="designated_group_options"
                                            class="b-form-input"
                                        ></b-form-select>
                                        <!-- <b-form-input aria-describedby="input-1-live-feedback" size="sm" type="text" class="b-form-input"></b-form-input> -->
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                    <!-- <b-form-group
                                        label-size="sm"
                                        label="Max Net Value Score:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-input
                                            v-model="certificate_details.max_net_value_score"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            class="b-form-input"
                                            type="text"
                                            v-on:keypress="NumbersOnly"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group> -->
                                    <b-form-group
                                        label-size="sm"
                                        label="Max Net Value Score:"
                                        label-for=""
                                        class="b-form-group align-text-setting"
                                        label-cols-sm="7"
                                    >
                                        <b-form-select
                                            v-model="certificate_details.max_net_value_score"
                                            aria-describedby="input-1-live-feedback"
                                            size="sm"
                                            :options="max_net_value_options"
                                            class="b-form-input"
                                        ></b-form-select>
                                        <!-- <b-form-input aria-describedby="input-1-live-feedback" size="sm" type="text" class="b-form-input"></b-form-input> -->
                                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                            Required
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <b-form-group
                                    label-size="sm"
                                    label="Black Economic Interest:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-input-group append="%" class="" size="sm">
                                        <b-form-input
                                            size="sm"
                                            v-model="certificate_details.black_economic_interest"
                                            class="b-form-input"
                                            type="number"
                                            min="0"
                                            max="100"
                                        ></b-form-input>
                                    </b-input-group>
                                </b-form-group>

                                <b-form-group
                                    label-size="sm"
                                    label="Black Women Economic Interest:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-input-group append="%" class="" size="sm">
                                        <b-form-input
                                            size="sm"
                                            v-model="certificate_details.black_women_economic_interest"
                                            class="b-form-input"
                                            type="number"
                                            min="0"
                                            max="100"
                                        ></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <!-- <b-form-group
                                    label-size="sm"
                                    label="Black Voting Rights:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="5"
                                >
                                    <b-form-input aria-describedby="input-1-live-feedback" size="sm" type="text" class="b-form-input"></b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group> -->
                                <b-form-group
                                    label-size="sm"
                                    label="Black Voting Rights:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-input-group append="%" class="" size="sm">
                                        <b-form-input
                                            size="sm"
                                            v-model="certificate_details.black_voting_rights"
                                            class="b-form-input"
                                            type="number"
                                            min="0"
                                            max="100"
                                        ></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group
                                    label-size="sm"
                                    label="Black Women Voting Rights:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-input-group append="%" class="" size="sm">
                                        <b-form-input
                                            size="sm"
                                            v-model="certificate_details.black_women_voting_rights"
                                            class="b-form-input"
                                            type="number"
                                            min="0"
                                            max="100"
                                        ></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </b-tab>
                            <b-tab v-if="findPermission('Add and Edit BEE Data') || isTypeUser" title="Quality Checking">
                                <b-form-group
                                    v-if="certificate_details.document_type == 'Affidavit'"
                                    label="Vetting Status:"
                                    label-size="sm"
                                    label-cols-sm="7"
                                    class="b-form-group align-text-setting"
                                >
                                    <b-form-select
                                        @change="onChangeVetting('vetting_status')"
                                        v-model="certificate_details.vetting_status"
                                        aria-describedby="input-1-live-feedback"
                                        :options="vetting_status_options_validation"
                                        size="sm"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group
                                    v-if="certificate_details.document_type == 'Affidavit'"
                                    label="Vetted By:"
                                    label-size="sm"
                                    label-cols-sm="7"
                                    class="b-form-group align-text-setting"
                                >
                                    <b-form-select
                                        @change="onChangeVetting('vetting_by')"
                                        v-model="certificate_details.vetting_by"
                                        aria-describedby="input-1-live-feedback"
                                        :options="team_member_options"
                                        size="sm"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group
                                    v-if="certificate_details.document_type == 'Affidavit'"
                                    label="Vetting Date:"
                                    label-size="sm"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-form-input
                                        disabled
                                        v-model="certificate_details.vetting_date"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        type="text"
                                        class="b-form-input not-allowed-pointer"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                        {{ vatNoErrorMessage }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group
                                    label-size="sm"
                                    label="BEE Data QC Status:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-form-select
                                        @change="onChangeBeeQcDataChange('bee_data_qc_status')"
                                        v-model="certificate_details.bee_data_qc_status"
                                        :options="bee_data_qc_status_options"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        class="b-form-input"
                                    ></b-form-select>
                                    <!-- <b-form-input aria-describedby="input-1-live-feedback" size="sm" type="text" class="b-form-input"></b-form-input> -->
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                    label-size="sm"
                                    label="BEE Data QC Notes:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-form-textarea
                                        v-model="certificate_details.bee_data_qc_notes"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        class="b-form-input"
                                    ></b-form-textarea>
                                    <!-- <b-form-input aria-describedby="input-1-live-feedback" size="sm" type="text" class="b-form-input"></b-form-input> -->
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                    label-size="sm"
                                    label="BEE Data Checked By:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-form-select
                                        @change="onChangeBeeQcDataChange('bee_data_checked_by')"
                                        v-model="certificate_details.bee_data_checked_by"
                                        :options="team_member_options"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        class="b-form-input"
                                    ></b-form-select>
                                    <!-- <b-form-input aria-describedby="input-1-live-feedback" size="sm" type="text" class="b-form-input"></b-form-input> -->
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                    label-size="sm"
                                    label="Checking Date:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-form-input
                                        disabled
                                        v-model="certificate_details.bee_data_check_date"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        type="text"
                                        class="b-form-input not-allowed-pointer"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                    label-size="sm"
                                    label="Random BEE Data QC Check By:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-form-select
                                        @change="onChangeBeeRandomCheckingDate()"
                                        v-model="certificate_details.bee_data_random_checked_by"
                                        :options="team_manager_options"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        class="b-form-input"
                                    ></b-form-select>
                                    <!-- <b-form-input aria-describedby="input-1-live-feedback" size="sm" type="text" class="b-form-input"></b-form-input> -->
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                    label-size="sm"
                                    label="Random BEE Data QC Notes:"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-form-textarea
                                        v-model="certificate_details.random_bee_data_qc_notes"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        class="b-form-input"
                                    ></b-form-textarea>
                                    <!-- <b-form-input aria-describedby="input-1-live-feedback" size="sm" type="text" class="b-form-input"></b-form-input> -->
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                    label-size="sm"
                                    label="Random BEE Data QC Checking Date"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-form-input
                                        disabled
                                        v-model="certificate_details.bee_data_random_check_date"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        type="text"
                                        class="b-form-input not-allowed-pointer"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group
                                    label="Vetting Date:"
                                    label-size="sm"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-form-input
                                        disabled
                                        v-model="certificate_details.vetting_date"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        type="text"
                                        class="b-form-input not-allowed-pointer"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                        {{ vatNoErrorMessage }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group label="QC Status:" label-size="sm" label-cols-sm="7" class="b-form-group align-text-setting">
                                    <b-form-select
                                        @change="onChangeQc('qc_status')"
                                        v-model="certificate_details.qc_status"
                                        aria-describedby="input-1-live-feedback"
                                        :options="qc_status_options"
                                        size="sm"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group label="QC By:" label-size="sm" label-cols-sm="7" class="b-form-group align-text-setting">
                                    <b-form-select
                                        @change="onChangeQc('qc_check_by')"
                                        v-model="certificate_details.qc_check_by"
                                        aria-describedby="input-1-live-feedback"
                                        :options="qc_user_options"
                                        size="sm"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group label="QC Date:" label-size="sm" label-for="" class="b-form-group align-text-setting" label-cols-sm="7">
                                    <b-form-input
                                        disabled
                                        v-model="certificate_details.qc_check_date"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        type="text"
                                        class="b-form-input not-allowed-pointer"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                        {{ vatNoErrorMessage }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group label="Random QC By:" label-size="sm" label-cols-sm="7" class="b-form-group align-text-setting">
                                    <b-form-select
                                        @change="onChangeRandomQc()"
                                        v-model="certificate_details.qc_random_check_by"
                                        aria-describedby="input-1-live-feedback"
                                        :options="team_manager_options"
                                        size="sm"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                    label="Random QC Date:"
                                    label-size="sm"
                                    label-for=""
                                    class="b-form-group align-text-setting"
                                    label-cols-sm="7"
                                >
                                    <b-form-input
                                        disabled
                                        v-model="certificate_details.qc_random_check_date"
                                        aria-describedby="input-1-live-feedback"
                                        size="sm"
                                        type="text"
                                        class="b-form-input not-allowed-pointer"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                                        {{ vatNoErrorMessage }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-tab>
                        </b-tabs>
                    </div>

                    <div class="group-of-buttons d-flex justify-content-center ml-3 mt-3">
                        <b-button @click="handleModal('certificateSharingModal')" variant="primary" type="button" class="btn btn-primary m-1 mt-2">
                            Sharing
                        </b-button>

                        <b-button
                            v-if="loggedIn_user_role == 'team_manager' && certificate_details.document_type == 'Certificate'"
                            @click="handleVetting"
                            variant="primary"
                            type="button"
                            class="btn btn-primary m-1 mt-2"
                        >
                            Authentication
                        </b-button>
                        <b-button
                            v-else-if="loggedIn_user_role == 'team_manager' && certificate_details.document_type == 'Affidavit'"
                            @click="handleVetting"
                            variant="primary"
                            type="button"
                            class="btn btn-primary m-1 mt-2"
                        >
                            Validation
                        </b-button>
                    </div>

                    <div class="group-of-buttons d-flex justify-content-center ml-3">
                        <div class="input-file m-1 mt-2">
                            <input @change="onFileSelected" class="btn btn-primary" ref="file" type="file" style="display: none;" />
                            <div class="btn btn-primary" @click="selectFile()">Upload</div>
                        </div>
                        <div :disabled="!selectedFile">
                            <b-button @click="newWindow" variant="primary" class="btn btn-primary m-1 mt-2"
                                ><i class="mdi mdi-dock-window mr-1"></i> View</b-button
                            >
                        </div>

                        <b-button
                            v-if="findPermission('Delete Certificates') || isTypeUser"
                            title="Quality Checking"
                            @click="deleteCertificate"
                            variant="danger"
                            type="button"
                            class=" btn btn-primary m-1 mt-2"
                        >
                            Delete Certificate
                        </b-button>
                    </div>
                </div>

                <div class="right-pane" v-if="certificate_details.certificate_src.length > 1 || certificate_details.new_certificate">
                    <embed v-if="certificate_details.new_certificate" :src="selectedFilePreview" class="w-100 h-100" />
                    <embed v-else :src="certificate_details.certificate_src" class="w-100 h-100" />
                </div>
                <!-- show if no certifacate in pane -->
                <div v-else class="right-pane d-flex justify-content-center">
                    <div class="text-center font-weight-bold ">Upload a certificate to preview it.</div>
                </div>
                <!-- </b-overlay> -->
            </div>

            <div class="modal-footer mt-3">
                <b-button @click="updateCertificateDetails" variant="primary" type="button" class="btn btn-primary">
                    Save
                </b-button>
                <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                    Close
                </b-button>
            </div>
        </b-overlay>
    </b-modal>
</template>

<script>
import Swal from "sweetalert2";
//eslint-disable-next-line
import { required, minLength, maxLength, numeric, date } from "vuelidate/lib/validators";
import { adminComputed, suppliersComputed, suppliersMethods } from "../../state/helpers";
//eslint-disable-next-line
import { read, utils } from "xlsx";

export default {
    data: () => ({
        hasMounted: false,
        formSubmit: false,
        show: false,
        selected_agency: null,
        file_upload_type: null,
        selectedFile: "https://www.africau.edu/images/default/sample.pdf#page=1&zoom=100&toolbar=0",
        selectedFilePreview: null,
        certificate_details: {
            active: null,
            certificate_id: "",
            //certificate
            company_name: "",
            company_size: null,
            verification_agency_id: null,
            sector_code_id: null,
            certificate_src: "",
            certificate_no: "",
            issue_date: "",
            expiry_date: "",
            vat_no: "",
            company_reg: "",
            bbbee_level: "",
            share_status: 0,
            document_type: null,
            new_certificate: null,

            //bee data
            own_score: "",
            mc_score: "",
            sed_score: "",
            esd_score: "",
            pp_score: "",
            sd_score: "",
            a2f_score: "",
            ef_score: "",
            ed_score: "",
            total_score: "",
            yes_enhancement: null,
            flow_through_applied: null,
            designated_group_supplier: null,
            max_net_value_score: "",
            black_economic_interest: "",
            black_women_economic_interest: "",
            black_voting_rights: "",
            black_women_voting_rights: "",
            //

            bee_data_qc_status: null,
            bee_data_checked_by: null,
            bee_data_check_date: "",
            bee_data_random_checked_by: null,
            bee_data_random_check_date: null,

            //quality checking
            vetting_status: null,
            vetting_by: null,
            vetting_date: null,
            qc_status: null,
            qc_check_by: null,
            qc_check_date: null,
            qc_random_check_by: null,
            qc_random_check_date: null,

            //
            bee_data_qc_notes: null,
            random_bee_data_qc_notes: null,
        },
        doc_type_options: [
            { value: "", text: "Please select an option", disabled: true },
            { value: "Certificate", text: "Certificate" },
            { value: "Affidavit", text: "Affidavit" },
        ],
        company_size_options: [
            { value: "", text: "Please select an option", disabled: true },
            { value: "Generic", text: "Generic" },
            { value: "EME", text: "EME" },
            { value: "QSE", text: "QSE" },
        ],
        sector_code_options: [
            { value: "", text: "Please select an option", disabled: true },
            { value: "1", text: "Accounting" },
            { value: "2", text: "Agri" },
            { value: "3", text: "Construction" },
            { value: "4", text: "Defence" },
            { value: "5", text: "DTIC" },
            { value: "6", text: "Financial" },
            { value: "7", text: "Forestry" },
            { value: "8", text: "ICT" },
            { value: "9", text: "Legal" },
            { value: "10", text: "MAC" },
            { value: "11", text: "Property" },
            { value: "12", text: "Tourism" },
            { value: "13", text: "Transport" },
        ],
        yes_enhancement_options: [
            { value: "", text: "Please select an option", disabled: true },
            { value: "1", text: "Yes" },
            { value: "0", text: "No" },
        ],
        max_net_value_options: [
            { value: "", text: "Please select an option", disabled: true },
            { value: "1", text: "Yes" },
            { value: "0", text: "No" },
        ],
        flow_through_applied_options: [
            { value: "", text: "Please select an option", disabled: true },
            { value: "1", text: "Yes" },
            { value: "0", text: "No" },
        ],
        designated_group_options: [
            { value: "", text: "Please select an option", disabled: true },
            { value: "1", text: "Yes" },
            { value: "0", text: "No" },
        ],
        vetting_status_options_authentication: [
            { value: "", text: "Please select an option", disabled: true },
            { value: "Not vetted", text: "Not vetted" },
            { value: "Authentic", text: "Authentic" },
            { value: "Altered", text: "Altered" },
            { value: "Not issued", text: "Not issued" },
            { value: "Withdrawn", text: "Withdrawn" },
        ],
        vetting_status_options_validation: [
            { value: "", text: "Please select an option", disabled: true },
            { value: "Not vetted", text: "Not vetted" },
            { value: "Valid", text: "Valid" },
            { value: "Invalid", text: "Invalid" },
        ],
        bee_data_qc_status_options: [
            { value: "", text: "Please select an option", disabled: true },
            { value: "TBC", text: "TBC" },
            { value: "OK", text: "OK" },
            { value: "Fix", text: "Fix" },
            { value: "Re-check", text: "Re-check" },
        ],
        qc_status_options: [
            { value: "", text: "Please select an option", disabled: true },
            { value: "Not checked", text: "Not checked" },
            { value: "TBC", text: "TBC" },
            { value: "OK", text: "OK" },
            { value: "Fix", text: "Fix" },
            { value: "Re-check", text: "Re-check" },
        ],
    }),
    validations: {
        certificate_details: {
            company_name: {
                required,
            },
            bbbee_level: {
                required,
            },
            company_size: {
                required,
            },
            sector_code_id: {
                required,
            },
            vat_no: {
                conditionalRequired(value) {
                    const isVatNoFilled = !!value;
                    const isCompanyRegFilled = !!this.certificate_details.company_reg;
                    return isVatNoFilled || isCompanyRegFilled;
                },
                minLength: minLength(10),
                maxLength: maxLength(10),
                numeric,
            },
            company_reg: {
                conditionalRequired(value) {
                    const isVatNoFilled = !!this.certificate_details.vat_no;
                    const isCompanyRegFilled = !!value;
                    return isVatNoFilled || isCompanyRegFilled;
                },
                minLength: minLength(3),
            },
            issue_date: {
                required,
            },
            expiry_date: {
                required,
            },
            document_type: {
                required,
            },
            verification_agency_id: { required },
        },
    },
    computed: {
        ...adminComputed,
        ...suppliersComputed,
        agency_options() {
            let agency_options = [{ value: "", text: "Please select an option", disabled: true }];

            this.agencies.map((agency) => {
                if (agency.name != "Affidavit") {
                    agency_options.push({ value: agency.id, text: agency.name });
                }
            });

            return agency_options;
        },
        team_member_options() {
            let teamMemberOptions = [{ value: "", text: "Please select an option", disabled: true }];

            this.teamMembersForCertificates.map((teamMember) => {
                teamMemberOptions.push({ value: teamMember.id, text: `${teamMember.first_name} ${teamMember.last_name}` });
            });

            return teamMemberOptions;
        },
        team_manager_options() {
            //eslint-disable-next-line
            console.log("team manager", this.teamManagersForCertificates);
            let teamManagerOptions = [{ value: "", text: "Please select an option", disabled: true }];

            this.teamManagersForCertificates.map((teamManager) => {
                teamManagerOptions.push({ value: teamManager.id, text: `${teamManager.first_name} ${teamManager.last_name}` });
            });

            return teamManagerOptions;
        },
        qc_user_options() {
            //eslint-disable-next-line
            console.log("qc users", this.qcUsersForCertificates);
            let teamQcUsers = [{ value: "", text: "Please select an option", disabled: true }];

            this.qcUsersForCertificates.map((qcMember) => {
                teamQcUsers.push({ value: qcMember.id, text: `${qcMember.first_name} ${qcMember.last_name}` });
            });

            return teamQcUsers;
        },
        bee_level_options() {
            // need to confirm the details here with api config

            return [
                { value: "", text: "Please select an option", disabled: true },
                { value: "1", text: "1" },
                { value: "2", text: "2" },
                { value: "3", text: "3" },
                { value: "4", text: "4" },
                { value: "5", text: "5" },
                { value: "6", text: "6" },
                { value: "7", text: "7" },
            ];
        },
        vatNoErrorMessage() {
            if (!this.$v.certificate_details.vat_no.$dirty) return "";
            if (!this.$v.certificate_details.vat_no.conditionalRequired) {
                return "Either a VAT No or Reg No must be provided.";
            }
            if (this.$v.certificate_details.vat_no.$error) {
                if (this.$v.certificate_details.vat_no.maxLength) {
                    return "VAT No must be 10 digits long.";
                }
                if (this.$v.certificate_details.vat_no.$params.numeric) {
                    return "Can only be numbers.";
                }
                return "A Vat No can only be 10 digits long.";
            }
            return "";
        },
        regNoErrorMessage() {
            if (!this.$v.certificate_details.company_reg.$dirty) return "";
            if (!this.$v.certificate_details.company_reg.conditionalRequired) {
                return "Either a Reg No or Vat no must be provided.";
            }
            if (this.$v.certificate_details.company_reg.$error) {
                if (this.$v.certificate_details.company_reg.$params.minLength) {
                    return "Reg No must be atleast 3 characters long";
                }
                return "Required";
            }
            return "";
        },
    },
    methods: {
        ...suppliersMethods,
        set_verification_agency() {
            if (this.certificate_details.document_type == "Affidavit") {
                this.certificate_details.verification_agency_id = "1";
            }

            if (this.certificate_details.document_type == "Certificate" && this.certificate_details.verification_agency_id == "1") {
                this.certificate_details.verification_agency_id = "";
            }
        },
        onChangeBeeQcDataChange(input) {
            if (input == "bee_data_qc_status") {
                this.certificate_details.bee_data_checked_by = "";
                this.certificate_details.bee_data_check_date = "";
            }

            if (input == "bee_data_checked_by") {
                this.certificate_details.bee_data_check_date = "";
            }
        },
        onChangeBeeRandomCheckingDate() {
            this.certificate_details.bee_data_random_check_date = "";
        },
        onChangeVetting(input) {
            if (input == "vetting_status") {
                this.certificate_details.vetting_by = "";
                this.certificate_details.vetting_date = "";
            }

            if (input == "vetting_by") {
                // this.certificate_details.vetting_status = null;
                this.certificate_details.vetting_date = "";
            }
        },
        onChangeQc(input) {
            if (input == "qc_status") {
                this.certificate_details.qc_check_by = "";
                this.certificate_details.qc_check_date = "";
            }

            if (input == "qc_check_by") {
                // this.certificate_details.qc_status = null;
                this.certificate_details.qc_check_date = "";
            }
        },
        //eslint-disable-next-line
        onChangeRandomQc() {
            this.certificate_details.qc_random_check_date = "";
        },
        // NumbersOnly(evt) {
        //     evt = evt ? evt : window.event;
        //     var charCode = evt.which ? evt.which : evt.keyCode;
        //     if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        //         // if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        //         evt.preventDefault();
        //     } else {
        //         return true;
        //     }
        // },
        // NumbersOnly(evt) {
        //     evt = evt ? evt : window.event;
        //     var charCode = evt.which ? evt.which : evt.keyCode;
        //     var inputField = evt.target;
        //     var currentValue = inputField.value;

        //     if (charCode === 44 || charCode === 46) {
        //         // Check if the input already contains a comma or a period
        //         if (currentValue.indexOf(",") !== -1 || currentValue.indexOf(".") !== -1) {
        //             evt.preventDefault();
        //         }
        //     } else if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        //         evt.preventDefault();
        //     } else {
        //         return true;
        //     }
        // },
        selectFile() {
            let fileInputElement = this.$refs.file;
            fileInputElement.click();
        },
        //eslint-disable-next-line
        NumbersOnly(evt) {
            return true;

            /*evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            var inputField = evt.target;
            var currentValue = inputField.value;
            
            if (charCode === 44 || charCode === 46) {
                // Check if the input already contains a comma or a period
                if (currentValue.indexOf(",") !== -1 || currentValue.indexOf(".") !== -1) {
                    evt.preventDefault();
                }
            } else if (charCode === 46 && currentValue.indexOf(".") !== -1) {
                // Allowing only one period in the input
                evt.preventDefault();
            } else if (charCode === 44 && currentValue.indexOf(",") !== -1) {
                // Allowing only one comma in the input
                evt.preventDefault();
            } else if (
                charCode !== 46 && // Allow the period for decimal point
                charCode !== 44 && // Allow the comma for decimal point
                (charCode < 48 ||
                charCode > 57 || // Check for non-numeric characters
                (currentValue.indexOf(",") !== -1 && currentValue.split(",")[1].length >= 2) || // Limit decimal places after a comma to 2
                    (currentValue.indexOf(".") !== -1 && currentValue.split(".")[1].length >= 2)) // Limit decimal places after a period to 2
            ) {
                evt.preventDefault();
            } else {
                return true;
            }*/
        },

        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.certificate_details[name];
                return $dirty ? !$error : null;
            }
        },
        closeModal() {
            // this.$refs["my-modal"].hide();
            this.formSubmit = false;
            // this.handleModal("certificateListModal");
            this.$emit("handleModal", "certificateListModal");
            this.$bvModal.hide("certificateEditModal");
        },
        onFileAdded(file) {
            //eslint-disable-next-line
            console.log("fileAdded", file);
            // file.error = true;
        },
        onFileSuccess() {
            //eslint-disable-next-line
            console.log("fileSuccess");
        },
        onFileError() {
            //eslint-disable-next-line
            console.log("fileError");
        },
        onFileSelected(event) {
            this.selectedFile = URL.createObjectURL(event.target.files[0]);
            this.selectedFilePreview = URL.createObjectURL(event.target.files[0]) + "#page=1&zoom=100&toolbar=0";

            this.certificate_details.new_certificate = event.target.files[0];
        },
        newWindow() {
            if (this.selectedFilePreview !== null) {
                window.open(this.selectedFilePreview, "_blank");
            } else {
                window.open(this.certificate_details.certificate_src, "_blank");
            }
        },

        updateCertificateDetails() {
            //eslint-disable-next-line
            console.log("the random check by", this.certificate_details.bee_data_random_checked_by);
            this.formSubmit = true;

            this.$v.certificate_details.$touch();
            if (this.$v.certificate_details.$anyError) {
                return;
            }
            this.show = true;

            Swal.fire({
                title: ` Update certificate details `,
                text: `Are you Sure you would like to update this certificates details`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Confirm",
            }).then((result) => {
                if (result.value) {
                    this.updateClientSupplierCertificateDetails(this.certificate_details).then(() => {
                        this.show = false;
                        Swal.fire("Certificate updated successfully", "", "success");
                        this.formSubmit = false;
                        this.closeModal();
                    });
                } else {
                    this.show = false;
                }
            });
        },
        localSetCertificateDetails() {
            //certificate tab
            this.certificate_details.certificate_id = this.selected_supplier_certificate.id;
            this.certificate_details.company_name = this.selected_supplier_certificate.company_name;
            this.certificate_details.company_size = this.selected_supplier_certificate.company_size;
            this.certificate_details.verification_agency_id = this.selected_supplier_certificate.verification_agency_id;
            this.certificate_details.sector_code_id = this.selected_supplier_certificate.sector_code_id;
            this.certificate_details.certificate_src = this.selected_supplier_certificate.certificate_src;

            if (this.certificate_details.certificate_src !== null) {
                this.certificate_details.certificate_src = this.certificate_details.certificate_src + "#page=1&zoom=100&toolbar=0";
            }

            this.certificate_details.certificate_no = this.selected_supplier_certificate.certificate_no;
            this.certificate_details.issue_date = this.selected_supplier_certificate.issue_date.substring(0, 10);
            this.certificate_details.expiry_date = this.selected_supplier_certificate.expiry_date.substring(0, 10);
            this.certificate_details.vat_no = this.selected_supplier_certificate.vat_no;
            this.certificate_details.company_reg = this.selected_supplier_certificate.company_reg;
            this.certificate_details.bbbee_level = this.selected_supplier_certificate.bbbee_level;
            this.certificate_details.share_status = this.selected_supplier_certificate.share_status;
            this.certificate_details.document_type = this.selected_supplier_certificate.document_type;

            //bbee data tab
            this.certificate_details.own_score =
                this.selected_supplier_certificate.own_score == null ? "" : this.selected_supplier_certificate.own_score;
            this.certificate_details.mc_score =
                this.selected_supplier_certificate.mc_score == null ? "" : this.selected_supplier_certificate.mc_score;

            this.certificate_details.sed_score =
                this.selected_supplier_certificate.sed_score == null ? "" : this.selected_supplier_certificate.sed_score;
            this.certificate_details.esd_score =
                this.selected_supplier_certificate.esd_score == null ? "" : this.selected_supplier_certificate.esd_score;
            this.certificate_details.pp_score =
                this.selected_supplier_certificate.pp_score == null ? "" : this.selected_supplier_certificate.pp_score;
            this.certificate_details.sd_score =
                this.selected_supplier_certificate.sd_score == null ? "" : this.selected_supplier_certificate.sd_score;
            this.certificate_details.a2f_score =
                this.selected_supplier_certificate.a2f_score == null ? "" : this.selected_supplier_certificate.a2f_score;
            this.certificate_details.ef_score =
                this.selected_supplier_certificate.ef_score == null ? "" : this.selected_supplier_certificate.ef_score;
            this.certificate_details.ed_score =
                this.selected_supplier_certificate.ed_score == null ? "" : this.selected_supplier_certificate.ed_score;

            this.certificate_details.total_score =
                this.selected_supplier_certificate.total_score == null ? "" : this.selected_supplier_certificate.total_score;

            this.certificate_details.yes_enhancement =
                this.selected_supplier_certificate.yes_enhancement == null ? "" : this.selected_supplier_certificate.yes_enhancement;
            this.certificate_details.flow_through_applied =
                this.selected_supplier_certificate.flow_through_applied == null ? "" : this.selected_supplier_certificate.flow_through_applied;
            this.certificate_details.designated_group_supplier =
                this.selected_supplier_certificate.designated_group_supplier == null
                    ? ""
                    : this.selected_supplier_certificate.designated_group_supplier;
            this.certificate_details.max_net_value_score =
                this.selected_supplier_certificate.max_net_value_score == null ? "" : this.selected_supplier_certificate.max_net_value_score;
            this.certificate_details.black_economic_interest =
                this.selected_supplier_certificate.black_economic_interest == null ? "" : this.selected_supplier_certificate.black_economic_interest;
            this.certificate_details.black_women_economic_interest =
                this.selected_supplier_certificate.black_women_economic_interest == null
                    ? ""
                    : this.selected_supplier_certificate.black_women_economic_interest;
            this.certificate_details.black_voting_rights =
                this.selected_supplier_certificate.black_voting_rights == null ? "" : this.selected_supplier_certificate.black_voting_rights;
            this.certificate_details.black_women_voting_rights =
                this.selected_supplier_certificate.black_women_voting_rights == null
                    ? ""
                    : this.selected_supplier_certificate.totblack_women_voting_rightsal_score;

            this.certificate_details.bee_data_qc_status =
                this.selected_supplier_certificate.bee_data_qc_status == null ? "" : this.selected_supplier_certificate.bee_data_qc_status;
            this.certificate_details.bee_data_qc_notes =
                this.selected_supplier_certificate.bee_data_qc_notes == null ? "" : this.selected_supplier_certificate.bee_data_qc_notes;
            this.certificate_details.random_bee_data_qc_notes =
                this.selected_supplier_certificate.random_bee_data_qc_notes == null
                    ? ""
                    : this.selected_supplier_certificate.random_bee_data_qc_notes;
            this.certificate_details.bee_data_checked_by =
                this.selected_supplier_certificate.bee_data_checked_by == null ? "" : this.selected_supplier_certificate.bee_data_checked_by;
            this.certificate_details.bee_data_check_date =
                this.selected_supplier_certificate.bee_data_check_date == null ? "" : this.selected_supplier_certificate.bee_data_check_date;
            this.certificate_details.bee_data_random_checked_by =
                this.selected_supplier_certificate.bee_data_random_checked_by == null
                    ? ""
                    : this.selected_supplier_certificate.bee_data_random_checked_by;
            this.certificate_details.bee_data_random_check_date =
                this.selected_supplier_certificate.bee_data_random_check_date == null
                    ? ""
                    : this.selected_supplier_certificate.bee_data_random_check_date;

            // TODO: needs active
            this.certificate_details.vetting_status =
                this.selected_supplier_certificate.vetting_status == null ? "" : this.selected_supplier_certificate.vetting_status;
            this.certificate_details.vetting_by =
                this.selected_supplier_certificate.vetting_by == null ? "" : this.selected_supplier_certificate.vetting_by;
            this.certificate_details.vetting_date =
                this.selected_supplier_certificate.vetting_date == null ? "" : this.selected_supplier_certificate.vetting_date;

            this.certificate_details.qc_status =
                this.selected_supplier_certificate.qc_status == null ? "" : this.selected_supplier_certificate.qc_status;
            this.certificate_details.qc_check_by =
                this.selected_supplier_certificate.qc_check_by == null ? "" : this.selected_supplier_certificate.qc_check_by;
            this.certificate_details.qc_check_date =
                this.selected_supplier_certificate.qc_check_date == null ? "" : this.selected_supplier_certificate.qc_check_date;
            this.certificate_details.qc_random_check_by =
                this.selected_supplier_certificate.qc_random_check_by == null ? "" : this.selected_supplier_certificate.qc_random_check_by;
            this.certificate_details.qc_random_check_date =
                this.selected_supplier_certificate.qc_random_check_date == null ? "" : this.selected_supplier_certificate.qc_random_check_date;
        },
        handleModal(modelName) {
            if (modelName == "certificateSharingModal") {
                this.$emit("handleModal", modelName);
                this.$bvModal.hide("certificateEditModal");
                return;
            }
            if (modelName == "certificateAuthenticationModal") {
                this.$emit("handleModal", modelName);
                this.$bvModal.hide("certificateEditModal");
                return;
            }

            if (modelName == "affidavitValidationModal") {
                this.$emit("handleModal", modelName);
                this.$bvModal.hide("certificateEditModal");
                return;
            }

            this.$emit("handleModal", modelName);
            this.localSetCertificateDetails();
            this.closeModal();
        },
        deleteCertificate() {
            Swal.fire({
                title: ` Are you Sure you would like to delete the certificate `,
                text: `This cannot be undone`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Confirm",
            }).then((result) => {
                if (result.value) {
                    this.deleteBEECertificate({ certificate_id: this.selected_supplier_certificate.id }).then(() => {
                        Swal.fire(`Certificate was deleted`, "", "success");
                        this.setSupplierCertificates(this.selected_supplier_details.id);
                        this.closeModal();
                    });
                }
            });
        },
        handleVetting() {
            if (this.certificate_details.document_type == "Certificate") {
                //eslint-disable-next-line
                this.handleModal("certificateAuthenticationModal");
                // this.closeModal();
            }

            if (this.certificate_details.document_type == "Affidavit") {
                //eslint-disable-next-line
                this.handleModal("affidavitValidationModal");
                // this.closeModal();
            }
        },
    },
    mounted() {
        this.setAgencies();
        this.setTeamMembersForCertificates();
        this.setCertificateById(this.selected_supplier_certificate.id).then(() => {
            //eslint-disable-next-line
            console.log("the console", this.selected_supplier_certificate.expiry_date);
            this.localSetCertificateDetails();
            this.hasMounted = true;
            //eslint-disable-next-line
            console.log(this.hasMounted);
        });
    },
    beforeDestroy() {
        this.localSetCertificateDetails();
    },
};
</script>

<style lang="scss">
//   the default style attached to modal footer  border-top: 1px solid #eff2f7;
.align-text-setting {
    text-align: right;
}
.height {
    min-height: 500px;
}

// this makes the left and right pane in the flex
.row-container {
    display: flex;
    padding: 10px;
}

.left-pane {
    width: 35%;

    .b-form-group {
        margin-right: 30px;
        margin-bottom: 10px;
    }
    .b-form-input {
        max-width: 100%;
    }
}
.group-of-actions {
    border-top: 1px solid #eff2f7 !important;
    margin-top: 25px;
    padding-top: 15px;
    margin-right: 25px;
}
.group-of-buttons {
    // border-top: 1px solid #eff2f7 !important;
    // margin-top: 25px;
    // padding-top: 15px;
    margin-right: 25px;
}

.right-pane {
    padding: 5px;
    width: 65%;
    display: flex;
    flex-direction: column;
    border: 1px solid black;
}

// the purpose of this media query is simply to make the contents of modal display flex-column
// and then for the panes to have a width off 100% instead of 50%
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
    .row-container {
        flex-direction: column;
    }

    .left-pane {
        width: 100%;
    }

    .right-pane {
        width: 100%;
        margin-top: 25px;
        height: 350px;
    }
}
.not-allowed-pointer {
    cursor: not-allowed;
}

.modal-xxl {
    width: 100%;
    max-width: 1350px;
}
</style>
